import React, { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { dispatcher } from 'dispatcher';
import { Icon } from 'js/components/common/Icon';
import { usePageSelector, useUserSelector } from 'js/store/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { Logo } from '../Logo';
import * as hooks from '../../hooks';
import { MyAccount } from '../MyAccount';
import { MyBalance } from '../MyBalance';
import { AdditionalUserInfo } from '../AdditionalUserInfo';

import style from './MobileHeader.scss';

export const MobileHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { overrideMenu, menuWcId } = usePageSelector(pick(['overrideMenu', 'menuWcId']));
    const hideSideMenuIcon = overrideMenu && !menuWcId;
    const openSideMenu = useCallback(() => dispatcher.dispatch('menu:action:open'), []);
    const { isShowBackButton, handleBackButtonClick } = hooks.useBackButton();

    return (
        <>
            <div className={style.header}>
                <div className={style.info}>
                    {!hideSideMenuIcon && !isShowBackButton && (
                        <Icon
                            type="sideMenu"
                            onClick={openSideMenu}
                            className={`${style.menu} cms-icon-side-menu`}
                            aria-label={translate('header.sideMenu.aria-label')}
                        />
                    )}
                    {isShowBackButton && (
                        <Icon
                            type="backButton"
                            onClick={handleBackButtonClick}
                            className="cms-icon-back-button"
                            aria-label={translate('header.backBtn')}
                        />
                    )}
                    <Logo />
                </div>
                <div className={style.controls}>
                    {isLoggedIn
                        ? (
                            <>
                                <MyBalance />
                                <MyAccount />
                            </>
                        )
                        : (
                            <Icon
                                type="headerLogin"
                                className="cms-icon-login"
                                onClick={onLoginButtonClick}
                                aria-label={translate('login.button.loginHeader')}
                            />
                        )
                    }
                </div>
            </div>
            <AdditionalUserInfo />
        </>
    );
};
